import { Injectable } from '@angular/core';
import { environment } from '../environments/environment';
import { Observable } from 'rxjs/internal/Observable';
import { HttpClient } from '@angular/common/http';

@Injectable({
  providedIn: 'root',
})
export class PontoService {
  private readonly baseUrl = environment.adminPortalUrl;

  constructor(private http: HttpClient) {}

  createInitialToken(vehicleId: string, payload: any): Observable<any> {
    return this.http.post(`${this.baseUrl}callback/vehicles/${vehicleId}/create-initial-token`, payload);
  }
}